module.exports = __webpack_public_path__ + "img/01-7.89c0afc3.png";